<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 wrapper-remates px-0 px-lg-3">
        <div class="w-100" v-if="remate.videoUrls.length > 0 && remate.videoUrls[0].liveVideo === true">
          <div
            class="btn btn-sm btn-applePrimary font-ARB text-uppercase text-darkPrimary border-radius-bottom-0 d-table px-3 mx-auto mx-lg-0">
            Ahora en vivo
          </div>
          <!--VIDEO-->
          <div class="wrapper-video ratio ratio-21x9">
            <iframe v-bind:src="remate.videoUrls[0].url"
              title="La Nación Remates" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <!--FIN VIDEO-->
        </div>
        <!-- REMATE DESTACADO -->
        <div class="card content-remate shadow flex-row flex-wrap border-0 rounded-0 mx-0 mb-3">
          <div class="col-12 col-lg-2 order-1 wrapper-feature px-0">
            <div class="row g-0 h-100 flex-row flex-lg-column">
              <div class="col-12 col-lg bg-primary">
                <div class="row g-0 h-100 flex-row">
                  <div
                    class="col col-lg-5 content-info wrapper-calendar d-flex flex-column justify-content-center align-items-center border-right-dotted border-white px-3 py-2">
                    <h5
                      class="fecha d-flex flex-column justify-content-center align-items-center font-ARB text-white text-center text-uppercase mb-0">
                      <span class="h2-md">{{ remate.fecha.dia_int }}</span>
                      <span class="mt-n1">{{ remate.fecha.mes_short }}</span>
                    </h5>
                  </div>
                  <div
                    class="col col-lg-7 content-info d-flex flex-lg-column align-items-center justify-content-between justify-content-lg-center border-bottom-dotted border-lightGray2 px-3 py-2 mt-lg-0">
                    <h5 class="font-ARB text-white">{{ remate.hora }}</h5>
                    <!-- IS LIVE -->
                    <div data-toggle="modal" @click="modalVideo(remate.id)"
                      v-if="remate.videoUrls.length > 0 && remate.isLive"
                      class="btn btn-sm btn-applePrimary font-ARB text-uppercase text-darkPrimary py-1 px-2">
                      En vivo
                    </div>
                    <!-- DIA -->
                    <div
                      class="btn btn-lightPrimary3 btn-sm small cursor-text font-ARB text-uppercase text-darkPrimary py-1 px-2"
                      v-if="remate.isLive === false && remate.fecha.dia === 'hoy'">
                      {{ remate.fecha.dia }}
                    </div>
                    <div
                      class="btn btn-sm small bg-darkPrimary cursor-text font-ARB text-uppercase text-white py-1 px-2 mb-0"
                      v-if="remate.isLive === false && remate.fecha.dia !== 'hoy'">
                      Próximo
                    </div>
                  </div>
                </div>
              </div>
              <!-- MODALIDAD -->
              <div class="col mt-auto d-block d-lg-none" v-if="mod == true">
                <div class="row h-100 flex-column flex-lg-row">
                  <div
                    class="col-12 col-lg-12 content-info wrapper-modalidad d-flex flex-wrap justify-content-center align-items-center py-2">
                    <div v-for="(mod, i) in remate.modalidad" 
                      class="ico-bg ico-bg-lg rounded-circle border border-borders bg-transparent float-left d-flex justify-content-center align-items-center mx-0 mx-md-1 mb-1 mb-lg-0">
                      <img v-bind:src="'/images/icons/modalidad/' + i + '-gray.png'" :alt="i" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3 wrapper-info order-2 mb-auto mb-lg-0 ps-3">
            <div class="row g-0 d-flex flex-row flex-wrap align-items-center py-2">
              <h5 class="col h5-sm font-ARB text-lightGray4 w-100 my-0 my-md-1">{{ remate.ubicacion.provincia }}{{
                remate.ubicacion.provincia ? "," : "" }} {{ remate.ubicacion.localidad }}</h5>
              <p class="p-sm font-AR text-lightGray4 w-100 mb-1"><b v-if="remate.especie">{{ remate.especie }}</b> <i
                  v-if="remate.destino">- {{ remate.destino }}</i></p>
              <p class="p-sm font-AR text-lightGray4 w-100 mb-1"><b>{{ remate.cantidad }}</b> <i>Animales</i></p>
            </div>
          </div>
          <!-- CABAÑAS & CONSIGNATARIOS -->
          <div class="col-12 col-lg-4 order-3 content-img d-flex justify-content-center align-items-center py-2">
            <!-- CONSIGNATARIO -->
            <img v-if="remate.consignatario.image" v-bind:src="remate.consignatario.image"
              :alt="remate.consignatario.nombre" class="img-fluid consignatario">
            <!-- CABAÑAS -->
            <div v-if="remate.tipo === 'Cabañas' && remate.cabanas.length > 0"
              class="content-cabañas row flex-nowrap g-0 justify-content-end ps-3">
              <div v-for="cabana in remate.cabanas" class="col px-1">
                <img v-bind:src="cabana.image" class="cabanas px-0" alt="cabañas">
              </div>
            </div>
          </div>
          <!-- BOTONERA -->
          <div class="col-12 col-lg-3 order-5 order-lg-4 content-botonera d-lg-flex px-3 px-lg-2 py-2">
            <div
              class="row g-0 w-100 align-items-center align-items-md-start justify-content-end justify-content-lg-start">
              <div
                class="col-5 col-lg content-media d-flex justify-content-start justify-content-lg-center align-items-center py-0 py-lg-1 me-3 me-lg-0">
                <!--galeria-->
                <a v-if="remate.galeria.length > 0" data-toggle="modal" @click="modalGaleria(remate.id)"
                  class="btn btn-outline-primary border-primary ico-bg rounded-circle d-flex justify-content-center align-items-center p-1">
                  <img src="/images/icons/share/camera.svg" alt="camara" class="img-fluid deselected">
                  <img src="/images/icons/share/camera-white.svg" alt="camera" class="img-fluid selected">
                </a>
                <!--videos-->
                <a v-if="remate.videoUrls.length > 0" data-toggle="modal" @click="modalVideo(remate.id)"
                  class="btn btn-outline-primary border-primary ico-bg rounded-circle d-flex justify-content-center align-items-center btn-video p-1">
                  <img src="/images/icons/share/video.svg" alt="video" class="img-fluid deselected">
                  <img src="/images/icons/share/video-white.svg" alt="video" class="img-fluid selected">
                </a>
                <!--share-->
                <div class="wrapper-share" @mouseleave="statusOff()">
                  <a
                    class="share btn btn-outline-primary border-primary ico-bg rounded-circle d-flex justify-content-center align-items-center p-2">
                    <img src="/images/icons/share/share.svg" alt="share" class="img-fluid deselected">
                    <img src="/images/icons/share/share-white.svg" alt="share" class="img-fluid selected">
                  </a>
                  <!-- Generated markup by the plugin -->
                  <div class="tooltip-container position-absolute">
                    <div class="row g-0 bg-darkPrimary p-1 px-2">
                      <button @click="copy(remate.id)"
                        class="col-4 copyLink btn btn-text d-flex align-items-center justify-content-center px-2 py-2">
                        <img src="/images/icons/share/link-white.svg" alt="copy link">
                        <p class="small tooltip-copyLink font-AR text-white bg-dark rounded-sm p-2"
                          :id="'myCopyLink-' + remate.id">Copiado!</p>
                      </button>
                      <a :href="'mailto:direccion@destinatario.com?&subject=LN%20Campo%20Remates&body=https://ln-campo.bd-it.com/remates%23remate-' + remate.id"
                        class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                          src="/images/icons/share/email-white.svg" alt="email"></a>
                      <a :href="'https://wa.me/?text=https://ln-campo.bd-it.com/remates%23remate-' + remate.id"
                        target="_blank" class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                          src="/images/icons/share/whatsapp-white.svg" alt="whatsapp"></a>
                      <!--<a @click="fb()" target="_blank" class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img src="/images/icons/share/facebook-white.svg" alt="facebook"></a>-->
                      <a :href="'https://twitter.com/intent/tweet?text=https://ln-campo.bd-it.com/remates%23remate-' + remate.id"
                        target="_blank" class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                          src="/images/icons/share/twitter-white.svg" alt="twitter"></a>
                      <a href="https://www.instagram.com/" target="_blank"
                        class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                          src="/images/icons/share/instagram-white.svg" alt="instagram"></a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-7 col-lg content-action d-flex flex-row flex-lg-column align-items-center justify-content-end justify-content-lg-center px-0 px-lg-1">
                <a v-if="remate.catalogoFile"
                  class="btn btn-outline-primary btn-sm border-primary font-ARB text-nowrap d-block py-2 me-2 me-lg-0 my-0 my-lg-1"
                  :href="remate.catalogoFile">
                  Catálogo
                </a>
                <a v-bind:id="'remateFeaturedDetalle-' + remate.id"
                  class="btn btn-outline-primary btn-sm btn-detalle text-uppercase ico-down-primary font-ARB text-nowrap d-block max-w-124 py-2 pe-4 my-0 my-lg-1"
                  data-bs-toggle="collapse" v-bind:data-bs-target="'#contentFeaturedDetalle-' + remate.id" role="button"
                  aria-expanded="false" v-bind:aria-controls="'contentFeaturedDetalle-' + remate.id">
                  <span>Ver más</span>
                  <span class="d-none ms-n1 pe-2">Ver menos</span>
                </a>
              </div>
            </div>
          </div>
          <!-- DETALLE -->
          <div class="col-12 order-4 order-lg-5 wrapper-detalle collapse"
            v-bind:id="'contentFeaturedDetalle-' + remate.id">
            <div class="row border-top border-borders px-3 py-3">
              <div class="col-12 col-md">
                <div class="content-info">
                  <h5 v-if="remate.consignatario.nombre" class="h5-sm font-AR text-lightGray4 mb-1"><span
                      class="text-primary font-ARB">Consignatario: </span>{{ remate.consignatario.nombre }}</h5>
                  <h5 v-if="remate.consignatario.email" class="h5-sm font-AR text-lightGray4 mb-1"><span
                      class="text-primary font-ARB">Mail: </span> <a :href="'mailto:' + remate.consignatario.email">{{
                        remate.consignatario.email }}</a></h5>
                  <h5 v-if="remate.consignatario.website" class="h5-sm font-AR text-lightGray4 mb-1"><span
                      class="text-primary font-ARB">Website:</span> <a :href="remate.consignatario.website"
                      class="hover-unlin">{{ remate.consignatario.website }}</a></h5>
                  <h5 v-if="remate.consignatario.telefono" class="h5-sm font-AR text-lightGray4 mb-1"><span
                      class="text-primary font-ARB">Teléfonos:</span>
                    {{ remate.consignatario.telefono }}</h5>
                  <h5 v-if="remate.martilleros" class="h5-sm content-martilleros font-AR text-lightGray4 mt-4">
                    <span class="text-primary font-ARB d-block">Martilleros:</span>
                    <span v-html="remate.martilleros"></span>
                  </h5>
                  <h5 class="description h5-sm font-AR text-lightGray4 mt-4" v-html="remate.descripcion"></h5>
                </div>
              </div>
              <!-- DESTACADOS -->
              <div v-if="remate.bannerDestacado" class="col-12 col-md-5 wrapper-destacado pt-3 pt-md-0 px-0 px-md-3">
                <div class="cont-img pt-0 ms-auto me-auto me-md-0">
                  <img v-bind:src="remate.bannerDestacado.image" :alt="remate.bannerDestacado.nombre">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END DESTACADO -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['remate'],
  methods: {
    fb() {
      FB.ui({
        method: 'share',
        href: 'https://developers.facebook.com/docs/',
      }, function (response) { });
    },
    statusOff() {
      let tooltip = document.querySelector(".tooltip-copyLink");
      tooltip.classList.remove('anima');
    },
    copy(id) {
      let copyText = `https://ln-campo.bd-it.com/remates#remate-${id}`;
      navigator.clipboard.writeText(copyText);
      let tooltip = document.getElementById(`myCopyLink-${id}`);
      tooltip.classList.add('anima');
      setTimeout(function () {
        tooltip.classList.remove('anima');
      }, 1500)
    },
    modalVideo: function (id) {
      axios.get('/modal_remates/' + id + '/video'
      ).then(response => {
        //console.log("Response data:",response.data);
        $("#modalWindowVideo").html(response.data);
      }).then(c => {
        $('#modalVideo-' + id).modal("show").on('shown.bs.modal', function () {
          var DivSwiper = '.sliderVideos';
          var swiper = new Swiper(DivSwiper + '  .swiper-container', {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 0,
            play: true,
            observer: true,
            observeParents: true,
            navigation: {
              nextEl: DivSwiper + ' .swiper-button-next',
              prevEl: DivSwiper + ' .swiper-button-prev',
            },
            grabCursor: true,
            pagination: {
              el: DivSwiper + '  .swiper-pagination',
              dynamicBullets: false,
              clickable: true
            }
          });
          console.log("Swiper loaded!");

          if ($(DivSwiper + " .swiper-slide").length == 1) {
            $(DivSwiper + " .swiper-pagination").addClass("disabled");
          }
        });

        $('#modalVideo-' + id).on('hidden.bs.modal', function () {
          var src = $(this).find('iframe').attr('src');
          $(this).find('iframe').attr('src', src);
        });
      });
    },
    modalGaleria: function (id) {
      axios.get('/modal_remates/' + id + '/galeria'
      ).then(response => {
        //console.log("Response data:",response.data);
        $("#modalWindowGaleria").html(response.data);
      }).then(c => {
        $("#modalGaleria-" + id).modal("show").on("shown.bs.modal", function () {
          var thumbs = new Swiper(".sliderThumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
          });
          console.log("Thumbs", thumbs);
          var swiper = new Swiper(".sliderContent", {
            spaceBetween: 10,
            navigation: {
              nextEl: ".sliderGaleria .swiper-button-next",
              prevEl: ".sliderGaleria .swiper-button-prev",
            },
            thumbs: {
              swiper: thumbs,
            },
          });
          console.log("Swiper loaded!");
        });
      });
    },
  },
  data() {
    return {
      isLoaded: false
    }
  },
  mounted() {
    //spinner
    this.isLoaded = true
  },
  computed: {},
};
</script>
<style lang="scss"></style>
